import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';

/**
 * Setter for window.location to make mocking easier.
 * For in-app navigation please use history utils
 */
export const redirectTo = (url, options) => {
  if (options !== null && options !== void 0 && options.newTab) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
};
export const getCmsUrl = () => `/website/${PortalIdParser.get()}/pages/site`;
export const getCtasDashboardUrl = () => `/calls-to-action/${PortalIdParser.get()}`;
export const getCtaEditorUrl = (ctaId, queryParams) => {
  const queryString = new URLSearchParams(queryParams).toString();
  return `/calls-to-action/${PortalIdParser.get()}/edit/${ctaId}/content?${queryString}`;
};
export const getLegacyCtasUrl = () => `/ctas/${PortalIdParser.get()}`;
export const getCampaignUrl = guid => `/marketing/${PortalIdParser.get()}/campaigns/${guid}`;
export const getLinkForWorkflows = flowId => {
  return `/workflows/${PortalIdParser.get()}/platform/flow/${flowId}/edit`;
};
export const getLinkForLists = listId => {
  return `/contacts/${PortalIdParser.get()}/objectLists/${listId}/filters/`;
};
export const getWebInteractiveImageUrl = contentId => {
  const prefix = enviro.ifHublet({
    isNa1: () => 'cta-service-cms2',
    isNonNa1: () => 'cta'
  });
  const domain = getFullUrl(prefix);
  return `${domain}/web-interactives/public/v1/embed/cta-image/${contentId}?portalId=${PortalIdParser.get()}`;
};